import { EventEmitter, ElementRef } from '@angular/core';
import { ApiService } from "../../app/api.service";
var componentMomentviewPro = (function () {
    function componentMomentviewPro(apiService, el) {
        this.apiService = apiService;
        this.el = el;
        this.onExit = new EventEmitter();
        this.currentIndex = 0;
        this.finished = false;
        this.momentFlag = false;
        this.tipFlag = true;
        this.momentContent = "";
        this.viewFlag = false;
    }
    componentMomentviewPro.prototype.ngOnInit = function () {
        var _this = this;
        if (this.momentList.length == 1) {
            this.momentList.push("no-active");
        }
        setTimeout(function () {
            _this.tipFlag = false;
        }, 2600);
    };
    componentMomentviewPro.prototype.ngAfterViewInit = function () {
        var _this = this;
        var hammertime = new Hammer($(this.el.nativeElement).find("#momentWrap")[0]);
        hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        hammertime.on('swipeleft swiperight', function (ev) {
            _this.momentEventType(ev, _this);
        });
    };
    componentMomentviewPro.prototype.loadConfigInfo = function (momentId) {
        return this.apiService.loadConfig("./assets/config/moment/" + momentId + "-1.json");
    };
    componentMomentviewPro.prototype.momentEventType = function (ev, that) {
        //向上
        if (ev.type == "swiperight") {
            if (that.currentIndex > 0) {
                that.currentIndex--;
                setTimeout(function () {
                    $('.next').show();
                }, 150);
            }
        }
        //向下
        if (ev.type == "swipeleft") {
            if (that.currentIndex < that.momentList.length - 1) {
                that.currentIndex++;
                setTimeout(function () {
                    $('.next').hide();
                }, 100);
            }
        }
    };
    componentMomentviewPro.prototype.showMoment = function ($event) {
        var _this = this;
        $event.stopPropagation();
        if (this.viewFlag) {
            return false;
        }
        this.viewFlag = true;
        setTimeout(function () {
            _this.viewFlag = false;
        }, 800);
        this.momentFlag = true;
        var configName = this.momentList[this.currentIndex];
        if (configName != "no-active") {
            this.loadConfigInfo(configName).subscribe(function (result) {
                if (result.length > 0 && result[0].begin.length > 0) {
                    _this.momentContent = $(result[0].begin[0].el).html();
                }
            });
        }
    };
    componentMomentviewPro.prototype.hideMoment = function () {
        var _this = this;
        if (this.viewFlag) {
            return false;
        }
        this.momentContent = "";
        this.viewFlag = true;
        setTimeout(function () {
            _this.viewFlag = false;
        }, 800);
        this.momentFlag = false;
    };
    componentMomentviewPro.prototype.ExitMoment = function () {
        this.onExit.emit();
    };
    return componentMomentviewPro;
}());
export { componentMomentviewPro };



// WEBPACK FOOTER //
// ./src/component/momentviewpro/component.momentview-pro.ts.pre-build-optimizer.js